import axios from 'axios'
import ElementUI from "element-ui";
import router from '../router'

// 测试
// localStorage.setItem("baseApi",'http://39.99.255.10:9040')

// 正式
// localStorage.setItem("baseApi",'http://123.56.47.201:48080')

// 正式
localStorage.setItem("baseApi",'http://dzsc.mdyzc.cn')


const request = axios.create({
    baseURL: localStorage.getItem("baseApi"),  
    timeout: 5000
})

// request 拦截器

request.interceptors.request.use(config => {
    config.headers['content-type'] = 'application/json;charset=utf-8';
    config.headers['tenant-id'] = '1';
    let loginMsg = localStorage.getItem("loginMsg")?JSON.parse(localStorage.getItem("loginMsg")):''
    if(loginMsg){
         config.headers['token'] = 'Bearer '+loginMsg.accessToken;  // 设置token
         config.headers['Authorization'] = 'Bearer '+loginMsg.accessToken;  // 设置token
		 let requestHeaders = {
			 'token':'Bearer '+loginMsg.accessToken,
			 'Authorization':'Bearer '+loginMsg.accessToken
		 }
		 localStorage.setItem("requestHeaders",JSON.stringify(requestHeaders))
    }
	// get请求映射params参数
	  if (config.method == 'get' && config.params) {
	    let url = config.url + '?';
	    for (const propName of Object.keys(config.params)) {
	      const value = config.params[propName];
	      const part = encodeURIComponent(propName) + '='
	      if (value !== null && typeof(value) !== "undefined") {
	        if (typeof value === 'object') {
	          for (const key of Object.keys(value)) {
	            let params = propName + '[' + key + ']';
	            const subPart = encodeURIComponent(params) + '='
	            url += subPart + encodeURIComponent(value[key]) + "&";
	          }
	        } else {
	          url += part + encodeURIComponent(value) + "&";
	        }
	      }
	    }
	    url = url.slice(0, -1);
	    config.params = {};
	    config.url = url;
	  }
	  //
	  
	if (config.method == 'get') {
	    config.data = {unused: 0} // 这个是关键点，加入这行就可以了  解决get  请求添加不上content_type 
	}
    return config
}, error => {
    return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
		
        let res = response.data;
        // 如果是返回的文件
        if (response.config.responsetype === 'blob') {
            return res
        }
        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
		
        // 发生错误，如token失效，则返回登录
        // if(res.code=='401' || res.code=='500'){
        if(res.code=='401'){
			//清除用户信息
			localStorage.setItem("loginMsg",'')
			localStorage.setItem("userMsg",'')
			localStorage.setItem("requestHeaders",'')
            ElementUI.MessageBox({
                title: '请重新登录',
                message: res.msg
            }).then(() =>{
                router.push('/login')
            } )
        }
        return res;
    },
    error => {
        console.log('err' + error) // for debug
        return Promise.reject(error)
    }
)


export default request

